import { selectMapOptions, selectPlaces, updateMapOption } from '../Map/mapSlice'
import { selectFilters, selectLocation } from '../menu/filtersSlice'
import { initialExp, finalExp } from 'utils/validation'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { generateBody } from '../Controller'
import { useEffect, useState } from 'react'
import { locationRequest } from 'rest/urls'
import Popup from 'components/popups/Popup'
import { POST } from 'rest/request'

const NewPlacePopup = () => {

  const { distance, position, voivodship } = useSelector(selectMapOptions)
  const filterLocation = useSelector(selectLocation)
  const filters = useSelector(selectFilters)
  const places = useSelector(selectPlaces)

  const [place, setPlace] = useState(null)
  const [isLoading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [form, setForm] = useState({
    location: filterLocation,
    phone: '',
    mail: ''
  })

  const { goBack, push } = useHistory()
  const { t } = useTranslation('map')
  const dispatch = useDispatch()

  const { location, phone, mail } = form
  const isDisabled = isLoading || !location || !phone || !mail


  useEffect(() => {
    if (places) {
      const nearest = places.reduce((r, e) => !e.distance || (r?.distance < e.distance) ? r : e, null)
      setPlace(nearest)
    }
  }, [places])

  const changeHandler = e => {
    if (!e) return
    const { name, value } = e.target
    if (name === 'location' || (!value || value.match(initialExp[name]))) setForm({
      ...form,
      [name]: value
    })
  }

  const submit = async () => {
    if (isDisabled) return
    try {
      const body = {
        ...generateBody(filters, position, distance, voivodship),
        location: filterLocation,
        email: mail,
        phone,
      }
      if (filterLocation !== location) {
        body.description = location
      }
      const response = await POST(locationRequest, { body })
      if (response) goBack()
    } catch (error) {
      setLoading(false)
    }
  }

  const validateForm = () => {
    const isMailOk = mail.match(finalExp.mail)
    const isPhoneOk = phone.match(finalExp.phone)
    if (location && isMailOk && isPhoneOk) {
      setErrors({})
      submit()

    } else {
      setErrors({
        location: !location,
        mail: !isMailOk,
        phone: !isPhoneOk
      })
    }
  }

  const getPlaceData = () => {
    const { id, gpslatitude, gpslongitude, distance } = place

    const showPlace = () => {
      if (!id) return
      goBack()
      if (gpslatitude && gpslongitude) dispatch(updateMapOption({
        mapPosition: [gpslatitude, gpslongitude]
      }))
      setTimeout(() => push(`/map/${id}`))
    }

    return <p>
      <span>{t('theNearest')} <u onClick={showPlace}>{t('yard')}</u>: <span style={{ color: 'var(--primary-color)' }}>{distance} km</span></span>
    </p>
  }

  return (
    <Popup
      centered
      isLine={false}>

      <div className='popup--newPlace'>
        {place && getPlaceData()}

        <div className={`popup__input${errors.location ? ' --error' : ''}`}>
          {(location || errors.location) && <div className='input__label'>{t('whereShouldWePutMag')}{errors.location ? ` - ${t('enterAddress')}` : ''}</div>}
          <input
            value={location}
            name='location'
            placeholder={t('whereShouldWePutMag')}
            onChange={changeHandler} />
        </div>

        <p>
          <span>{t('notifications')}</span>
          <span>{t('completeToReceiveInformationAboutConstruction')}</span>
        </p>

        <div className={`popup__input${errors.phone ? ' --error' : ''}`}>
          {(phone || errors.phone) && <div className='input__label'>{t('phoneNumber')}{errors.phone ? ` - ${t('enterTheCorrectOne')}` : ''}</div>}
          <input
            value={phone}
            name='phone'
            type='tel'
            placeholder={t('phoneNumber')}
            onChange={changeHandler} />
        </div>

        <div className={`popup__input${errors.mail ? ' --error' : ''}`}>
          {(mail || errors.mail) && <div className='input__label'>{t('emailAddress')}{errors.mail ? ` - ${t('enterTheCorrectOne')}` : ''}</div>}
          <input
            value={mail}
            name='mail'
            placeholder={t('emailAddress')}
            onChange={changeHandler} />
        </div>

        <div className='popup__buttons center'>
          <div
            className='button__cancel --secFont'
            onClick={goBack}>{t('close')}</div>
          <div
            className='button__submit --secFont'
            style={isDisabled ? { opacity: 0.5 } : undefined}
            onClick={validateForm}>{t('report')}</div>
        </div>
      </div>
    </Popup>
  )
}

export default NewPlacePopup